import { MyCourseCategory } from "./MyCourseCategory";
import { MyCourseDescription } from "./MyCourseDescription";
import { MyCourseMedia } from "./MyCourseMedia";
import { MyCourseName } from "./MyCourseName";
import { MyCourseRequirement } from "./MyCourseRequirement";

export function MyCourseBasicInfo() {
	return (
		<div className="my-course-basic-info-container">
			<MyCourseDescription />
			<div className="section-separator" />
			<MyCourseName />
			<div className="section-separator" />
			<MyCourseMedia />
			<div className="section-separator" />
			<MyCourseCategory />
			<div className="section-separator" />
			<MyCourseRequirement />
		</div>
	);
}
